const TRANSLATION = {
  common: {
    loading: '加载中',
  },
  i18n: {
    English: '英语',
    Spanish: '西班牙语',
    Russian: '俄语',
    'Portuguese (Brazil)': '葡萄牙语（巴西）',
    Indonesian: '印度尼西亚语',
    Czech: '捷克语',
    German: '德语',
    French: '法语',
    Italian: '意大利语',
    Dutch: '荷兰语',
    Polish: '波兰语',
    Vietnamese: '越南语',
    Turkish: '土耳其语',
    Ukrainian: '乌克兰语',
    Chinese: '简体中文',
    'Traditional Chinese': '繁体中文',
    Japanese: '日语',
    Korean: '韩语',
    Arabic: '阿拉伯语',
    Persian: '波斯语',
    Thai: '泰语',
    Hindi: '印地语',
    Malay: '马来语',
    province: {
      Hebei: '河北省',
      Shanxi: '山西省',
      Liaoning: '辽宁省',
      Jilin: '吉林省',
      Heilongjiang: '黑龙江省',
      Jiangsu: '江苏省',
      Zhejiang: '浙江省',
      Anhui: '安徽省',
      Fujian: '福建省',
      Jiangxi: '江西省',
      Shandong: '山东省',
      Henan: '河南省',
      Hubei: '湖北省',
      Hunan: '湖南省',
      Guangdong: '广东省',
      Hainan: '海南省',
      Sichuan: '四川省',
      Guizhou: '贵州省',
      Yunan: '云南省',
      Shaanxi: '陕西省',
      Gansu: '甘肃省',
      Qinghai: '青海省',
      Taiwan: '台湾省',
      Guangxi: '广西壮族自治区',
      Neimenggu: '内蒙古自治区',
      Tibet: '西藏自治区',
      Ningxia: '宁夏回族自治区',
      Xinjiang: '新疆维吾尔自治区',
      HongKong: '香港特别行政区',
      Macau: '澳门特别行政区',
      Beijing: '北京市',
      Tianjin: '天津市',
      Shanghai: '上海市',
      Chongqing: '重庆市',
    },
  },
  pageHeader: {
    product: '产品',
    tvcTest: '横屏-创意诊断',
    tvcEval: '横屏-深度洞察',
    contactUs: '联系我们',
    Pricing: '定价',
    Dashboard: '立即开始',
    signIn: '登入',
    signUp: '注册',
    resourceCenter: '资源中心',
    all: '全部',
    news: '新闻',
    insight: '洞察',
    case: '案例',
  },
  productSwitch: {
    common: {
      comingSoon: '即将上线',
    },
    modal: {
      heroTitle: '请选择您想要进行的测试',
      heroSubtitle: 'AdEff 随时为您提供多维度的创意洞察。',
      remainingTimes: '剩余次数：{{count}}',
      supportedAssets: '适用素材',
      coreMetrics: '核心指标',
      cognitiveNeuroscienceIndicators: '认知神经指标',
      consumerAttitudeIndicators: '消费者态度指标',
      outputResult: '输出结果',
      dataReport: '数据报告',
      analysisReport: '分析报告',
      accessBackend: '立即开始',
      tabs: {
        tvc: '横屏创意测试',
        portrait: '竖屏创意测试',
      },
      cards: {
        tvcQuick: {
          title: '横屏-快测',
          descriptionHighlight: '多中选优，快速决策',
        },
        tvcBase: {
          title: '横屏-创意诊断',
          descriptionHighlight: '精细打磨创意细节，提供可落地的修改建议',
          value1: '10-60秒TVC/OTV创意',
          value2: '认知神经指标',
        },
        tvcSurvey: {
          title: '横屏-深度洞察',
          descriptionHighlight: '多维评估创意表现，提供创意优化策略指导',
          value1: '10-60秒TVC/OTV创意',
          value2: '认知神经指标',
        },
        portraitQuick: {
          title: '竖屏-快测',
          descriptionHighlight: '多中选优，快速决策',
        },
        portraitBase: {
          title: '竖屏-创意诊断',
          descriptionHighlight: '精细打磨创意细节，提供可落地的修改建议',
          value1: '5-90秒竖屏创意',
          value2: '认知神经指标',
        },
        portraitSurvey: {
          title: '竖屏-深度洞察',
          descriptionHighlight: '多维评估创意表现，提供创意优化策略指导',
          value1: '5-90秒竖屏创意',
          value2: '认知神经指标',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: '横屏创意测试',
          assetText: '适用于10-60秒TVC/OTV创意',
        },
        portrait: {
          bannerTitle: '竖屏创意测试',
          assetText: '适用于5-90秒竖屏创意',
        },
      },
      items: {
        tvcQuick: {
          description: '又快又准，选出最优',
        },
        tvcBase: {
          title: '创意诊断',
          description: '逐秒优化，精雕创意',
        },
        tvcSurvey: {
          title: '深度洞察',
          description: '全面剖析，定位症结',
        },
        portraitBase: {
          title: '创意诊断',
          description: '逐秒优化，精雕创意',
        },
        portraitQuick: {
          description: '又快又准，选出最优',
        },
        portraitSurvey: {
          title: '深度洞察',
          description: '全面剖析，定位症结',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: '我们使用cookies',
    desc: '我们使用必要的cookies确保我们的网站正常运行。在您的同意下，我们还使用分析cookies来改善您的用户体验。查看我们的Cookie政策在我们的隐私政策中。',
    btn1: '拒绝所有',
    btn2: '接受所有',
    cookiePolicy: 'Cookie政策',
  },
  landing: {
    banner: {
      text1: 'AI驱动',
      text2: '广告',
      text3: '测试',
      text4: '创意测试和优化平台',
      feature1: '内容解码',
      feature2: '反馈预测',
      feature3: '数据整合',
      feature4: '结论推理',
      btn1: '获取演示',
      btn2: '创建项目',
    },
    info: {
      title: '基于超图多模态大语言模型（HMLLM）*，快速实现创意的效果预测，提升广告投资回报',
      subTitle: '*此模型基于大量神经营销学测试与多智能体构建',
      detail1: '快速广告测试',
      detail1Desc:
        'AdEff可以在15分钟内获得目标受众注意力曲线、情感波动以及对创意内容的参与度，并提供详细评估报告及优化指导。',
      detail2: '快速筛选最优创意',
      detail2Desc: 'AdEff支持对多个创意的同时测量，帮助品牌做出快速决策。并提供详细对比分析。',
      detail3: '一键剪辑，生成多样有效版本',
      detail3Desc: 'AdEff支持一键剪辑，可快速生成多样有效版本，适用于多种传播场景。',
    },
    advantages: {
      title: 'AdEff优势',
      item1Title: '快速响应',
      item1Desc: '最快 <tmp>15分钟</tmp> 即可获得报告。',
      item2Title: '独特的AI模型',
      item2Desc: '独有基于受众反馈的 <tmp>AI模型</tmp>。',
      item3Title: '可视化图表',
      item3Desc: '<tmp>可视化图表</tmp>+AI智能解读，测试报告一键生成',
      item4Title: '庞大的数据范围',
      item4Desc: '<tmp>50,000+</tmp> 创意数据库',
      item5Title: '专家团队',
      item5Desc: '<tmp>专家团队</tmp>提供支持和指导',
    },
    service: {
      title: 'AdEff服务方式',
      desc: '选择您需要的服务方式',
      topTitle: '在线自助服务',
      topRow1: '自主建项完成测试',
      topRow2: '可视化图表 + AI解读报告',
      topRow3: '客观神经科学指标分析（眼动 + 脑电）',
      topRow4: '独有AI模型测试',
      bottomTitle: '专家团队服务',
      bottomRow1: '专家建项完成测试',
      bottomRow2: '客观神经科学指标分析（眼动 + 脑电）、可选增加主观指标',
      bottomRow3: '可视化图表 + 专家解读报告',
      bottomRow4: '独有AI模型测试、可选真人样本测试',
    },
    footer: {
      title:
        'AdEff依托于超图多模态大语言模型（HMLLM），通过超图构建视觉元素EEG信号和眼动追踪数据之间的复杂关系，实现广告创意的快速测试',
      email: '电子邮箱',
      belongDesc: '<tmp>明略科技</tmp>旗下产品',
    },
    startBtn: '立即开始',
  },
  contact: { title: '联系我们', copy: '复制', message: { success: '复制成功' } },
  pricing: {
    title: 'AI驱动的创意测试及优化专家',
    starter: {
      title: '基础版',
      desc_1: '适用于单次测试，即买即用',
      desc_2: '适用于少量测试，即买即用',
      timesDesc: '<strong>{{count}}</strong>次测试',
      timesDesc1: '<strong>{{count}}</strong>次测试',
      discount: '限时5折',
      originPrice: '原价',
      desc2: '基于受众反馈的超图多模态大语言模型',
      desc3: '快速响应，最快15分钟即可生成报告',
      desc4: '丰富的可视化图表',
      desc5: '专业的AI智能解读',
      desc6: '全球数据库与基准',
      cardDesc1: '限时折扣，仅需{{pricePerTest}}',
      cardDesc2: '次数永久有效',
    },
    premium: {
      time: '次',
    },
    unlimited: {
      title: '无限版',
      cardDesc1: '低至{{pricePerTest}}',
      cardDesc2: '次数有效期为一年',
      cardDesc3: '定制自有基准值',
      planDesc500: '全年畅享500次测试',
      planDesc1000: '全年畅享1,000次测试',
    },
    benefits: {
      title: '为什么选择AdEff?',
      subtitle: '购买AdEff，您可以获得以下权益：',
      expertSupport: '专家团队提供支持和指导',
      moreNeedsTitle: '有其他购买需求？',
      customPlanPrefix: '我们支持多种灵活与定制化方案——欢迎联系我们',
      customPlanSuffix: '获取专属方案',
    },
    subscribeBtn: '立即订阅',
    contactUs: '联系我们',
  },
  login: {
    loginText: '登录',
    signUpText: '免费<tmp>注册</tmp>',
    text1: '成功加入团队',
    text1Desc:
      'AdEff基于超图多模态大语言模型（HMLLM），构建视觉元素EEG信号和眼动追踪数据之间的复杂关系，实现广告创意的快速测试',
    text2: '用户已加入企业',
    text3: '团队邀请已过期',
    text4: '团队邀请链接不再有效。',
    optionText1: '已经有帐户？',
    optionText2: '没有帐户？',
    alertText1: '注册即同意',
    alertText2: '注册即同意',
    termsOfService: '服务条款',
    privacy: '隐私政策',
    privacyTips: '请在注册前勾选同意协议。',
    and: '和',
    or: '或',
    next: '下一步',
    googleLogin: 'Google邮箱登录',
    googleSignUp: 'Google邮箱注册',
    loginWithEmail: '电子邮箱登录',
    signUpWithEmail: '邮箱账号注册',
    password: '密码',
    emailAddress: '账号',
    enterEmail: '输入您的电子邮箱',
    enterPassword: '输入您的密码',
    confirmPassword: '确认密码',
    forgotPassword: '忘记密码？',
    inconsistentPassword: '密码不一致',
    verificationCode: '验证码',
    emptyVerificationCode: '验证代码不能为空',
    enterVerificationCode: '输入验证代码',
    sendedVerificationCode: '验证代码已发送到您的电子邮件',
    emailOrPasswordNotCorrect: '电子邮箱或密码不正确。',
    message: {
      text1: '输入内容无效',
      text2: '电子邮箱已经注册',
      text3: '验证代码验证错误！',
      text4: '该帐户没有绑定到企业，请重新结合！',
      text5: '请输入正确的电子邮箱格式',
      text6: '密码长度不能小于12位',
      text7: '密码必须包含大写字母、小写字母和数字',
      requestLimit: '请求超限，请稍后再试',
    },
  },
  resetPwdPage: {
    submit: '提交',
    emailNotFound: '请检查电子邮箱',
    emailHasSent: '电子邮件已发送至 {{email}}',
    checkYourInbox: '检查您的电子邮件',
    resetYourPassword: '重置密码',
    resetLinkHasSent: '重置密码链接已发送至您关联的电子邮箱，请检查您的电子邮件',
    enterYourEmailAddress: '输入您的电子邮箱地址',
    didNotGetEmail: '未收到电子邮件？',
    tryAgain: '重试',
    goBackToSign: '返回登录',
    email: '电子邮箱',
    enterYourEmail: '输入您的电子邮箱',
    resetPassword: '重置密码',
    resetPwdSuccess: '密码重置成功',
    message: {
      resetLinkCodeError: '链接中的代码无效',
      requestLimit: '请求超限，请稍后再试',
    },
  },
  memberRequestPage: {
    title: '验证成员请求',
    subTitle: '请求来自：',
    deny: '拒绝',
    approve: '同意',
    teamFull: '团队满员',
    yourTeamIsFull: '您的团队已满。您可以联系我们获取更多会员或删除其他成员。',
    manageMembers: '管理 AdEff 中的成员',
    requestApproved: '已同意请求',
    approvedDesc: '您已同意 <tmp>{{name}}</tmp> 加入您的团队，已自动发送通知邮件。',
    requestDeclined: '已拒绝请求',
    declinedDesc: '您已拒绝 <tmp>{{name}}</tmp> 加入您的团队，已自动发送通知邮件。',
  },
  infoBindPage: {
    title: 'AI驱动广告测试',
    desc: '基于超图多模态大语言模型（HMLLM）*，快速实现创意的效果预测，提升广告投资回报',
    joinAdEff: '加入 AdEff 并开启新旅程',
    advantages: {
      title1: '更强大',
      desc1: '基于庞大数据库的独特AI模型',
      title2: '更经济',
      desc2: '只需传统方式的10%价格',
      title3: '更快速',
      desc3: '最快15分钟即可获取报告',
      title4: '更专业',
      desc4: '享受24/7的服务支持，和专家团队服务',
    },
    username: '用户名',
    company: '公司',
    placeOfResidence: '国家/区域',
    invitationCode: '推荐码',
    createAccountForFree: '免费创建帐户',
    refreshStatus: '刷新状态',
    reapply: '重新申请',
    bySigningUp: '注册即同意',
    termsOfService: '服务条款',
    and: '和',
    privacyPolicy: '隐私政策',
    message: {
      success: '已发送创建帐户的请求，请耐心等待！',
      success2: '帐户创建成功',
      error: '帐户创建失败，请稍后再试。',
      accountCreatedDirectly: '已为您直接创建帐户！',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou: '请求已通过，页面将自动跳转。',
      theRequestHasBeenSendAndPleaseBePatient: '已发送请求，请耐心等待！',
      wrongRouting: '路由错误，页面将自动跳转。',
      yourRequestHasBeenDeclined:
        '您的请求已被拒绝。您可以重新申请加入团队或创建一个没有邀请码的新帐户。',
      waitingForAdministratorReview: '等待管理员审核',
      thisFieldIsRequired: '此字段为必填项',
      pleaseEnterTheResidence: '请输入国家',
      invitationCodeDoesNotExist: '推荐码有误',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere: '如果您因代理推荐使用，请输入推荐码',
      pleaseEnterTheUsername: '请输入用户名',
      pleaseEnterTheCompanyName: '请输入公司名称',
      needRegisterAgain: '操作异常，请重新注册',
      alreadyBind: '您已绑定企业，请勿重复绑定',
    },
  },
  knowledgeFormPage: {
    name: '您的姓名',
    email: '您的邮箱',
    companyName: '公司名称',
    department: '部门',
    role: '职位',
    country: '国家',
    province: '省份',
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    pleaseEnterTheName: '请输入您的姓名',
    pleaseEnterTheEmail: '请输入您的邮箱',
    pleaseEnterValidEmail: '请输入有效的邮箱',
    pleaseEnterTheCompanyName: '请输入您的公司名称',
    pleaseSelectTheDepartment: '请选择您的部门',
    pleaseSelectTheRole: '请选择您的职位',
    pleaseSelectTheCountry: '请选择您的国家',
    pleaseSelectTheProvince: '请选择您的省份',
    textIsRequired: '此字段为必填项',
    submit: '提交',
    download: '下载',
    submitSuccess: '提交成功',
    downloadSuccess: '下载成功',
    title1: '请填写您的信息以获取资源',
    title2: '请选择您想要下载的资源',
  },
  dashboard: {
    pdf: {
      downloadReport: '下载报告',
      downloadBtnText: 'PDF下载',
      content: '内容',
      theEnd: '结束',
      thankYouForWatching: '感谢观看。',
      pdfProcessing: '处理 PDF 中...',
      pdfProcessingDesc:
        'PDF 页数：{{count}}，数量较多，预计需要 {{seconds}} 秒，点击保存后，请耐心等待',
      pdfProcessingDesc2: '当前语言版本未进行翻译，无法生成 PDF',
    },
    ppt: {
      downloadBtnText: 'PPT下载',
      pptProcessingDesc: 'PPT 文件生成中，请耐心等待',
      pptProcessingDesc2: '当前语言版本未进行翻译，无法生成 PPT',
      pptProcessingDesc3: 'PPT 文件下载中，请稍候',
      translateCompleted: 'PPT 翻译完成',
      exportSuccess: 'PPT 文件导出成功',
      exportFailed: 'PPT 文件导出失败',
    },
    layout: {
      projectMenuText: '广告测试项目',
      accountManagementText: '帐户管理',
      myAccountText: '我的账户',
      subscriptionText: '订阅',
      logout: '退出登录',
      dataDetails: '数据详情',
      dataAnalysis: '数据分析',
      dataOverview: '数据总览',
      dataComparison: '数据对比',
    },
    systemMessage: {
      title: '系统消息',
      task: '任务',
      system: '系统',
      noRelevantContent: '找不到相关内容',
      noMore: '没有更多消息',
    },
    projectPage: {
      createProject: '创建项目',
      searchPlaceholder: '输入项目/广告/品牌名称搜索',
      sortLabel: '广告效果指数排序',
      sortPlaceholder: '请选择排序方式',
      sortOption1: '按照效果指数正序',
      sortOption2: '按照效果指数倒序',
      filterSort: '筛选与排序',
      filterBenchmarkTitle: '筛选基准值',
      sortTitle: '排序',
      tabAllCreative: '全部创意（{{count}}）',
      tabGeneralCreative: '常规创意（{{count}}）',
      tabSplashCreative: '开屏创意（{{count}}）',
      generalCreativeLabel: '常规创意',
      splashCreativeLabel: '开屏创意',
      normTypePlaceholder: '请选择基准值类型',
      totalDesc: '广告项目（共{{total}}个）',
      noRelevantContent: '找不到相关内容',
      loadMore: '加载更多',
      projectCard: { delete: '删除', reanalyze: '重新分析', download: '下载' },
      delete: '删除',
      cancel: '取消',
      message: {
        deleteTitle: '删除提醒',
        delete: '一旦删除此项目，所有关联的数据将变得不可访问。您确定要继续删除吗？',
        delete1: '本项目为试用项目，删除后不会返还试用机会',
        delete2: '本项目尚未开始分析，删除后将为您返还测试次数',
        deleteSuccess: '删除成功！',
        analysisCountNotEnough: '分析次数不足，请充值后进行尝试。',
        analysisFailed: '分析失败，请稍后再试。',
        waitingQuestion: '最多同时分析3个项目。该项目已进入等待队列，稍后自动开始分析。',
        landscapeQuickCompleted: '您的横屏-快测项目已完成',
        portraitQuickCompleted: '您的竖屏-快测项目已完成',
        landscapeSurveyCompleted: '您的横屏-深度洞察项目已完成',
        portraitSurveyCompleted: '您的竖屏-深度洞察项目已完成',
      },
    },
    projectCreatePage: {
      createProject: '创建项目',
      basicInformation: '基本信息',
      projectType: '项目类型',
      projectName: '项目名称',
      categoryType: '行业',
      brandName: '品牌名称',
      advertisingInformation: '广告信息',
      adName: '广告名称',
      norm: '基准值',
      targetMarketNorm: '目标市场基准值',
      brandNorm: '品牌基准值',
      taGender: 'TA 性别',
      targetMarket: '目标市场',
      taAge: 'TA 年龄',
      next: '下一步',
      previous: '上一步',
      confirmOrder: '确认订单',
      estTime: '预估时间',
      minutes: '分钟',
      consumption: '本次订单消耗',
      testPoint: '测试次数',
      remaining: '剩余',
      times: '次',
      type: '类型',
      purchase: '购买',
      outputLanguage: '输出语言',
      durationCategory: '创意类型',
      durationCategoryDesc: '不同创意类型对应分析指标不同，请选择最符合当前素材的选项',
      durationCategoryOptions: {
        tenPlus: '常规创意（10秒+）',
        fiveToTen: '开屏创意（5-10秒）',
      },
      adSelection: {
        adCreativeTest: '广告创意测试',
        adCreativeTestDesc: '测试单广告创意的受众反馈，提供分析与建议',
        adCreativeSelection: '广告创意遴选',
        adCreativeSelectionDesc: '对比多个广告创意的反馈效果，综合对比选择',
        adCreativeEditing: '广告创意剪辑',
        adCreativeEditingDesc: 'AI智能筛选广告创意中的精华部分，自动生成广告创意',
        launchingSoon: '即将上线',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: '食品饮料类',
        packagedFood: '包装食品',
        confectionery: '糖果/甜食',
        frozenMeals: '速冻食品',
        fastFood: '快餐',
        beverage: '饮料',
        alcohol: '酒精',
        dairy: '乳制品',
        grainAndSeasoning: '粮油调味',
        beverageMixes: '冲饮冲调',
        freshProduce: '生鲜果蔬',
        otherFoodAndBeverage: '其他食品饮料',
        /**----------------------- */
        consumerElectronicsCategory: '消费者电子产品类',
        mobilePhone: '手机',
        computer: '电脑',
        smartDevice: '智能设备',
        phoneAccessories: '手机配件',
        computerAccessories: '电脑配件',
        software: '软件',
        camera: '照相机',
        officeSupplies: '办公用品',
        otherConsumerElectronics: '其他电子产品',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: '医药保健类',
        otcMedicine: '非处方药品',
        prescriptionDrugs: '处方药品',
        healthSupplements: '保健药品',
        pharmaceuticalCompanies: '制药公司',
        medicalDevices: '医疗器械',
        medicalServices: '医疗服务',
        pharmacy: '药店',
        otherPharmaceuticalsAndHealthCare: '其他医药保健',
        /**----------------------- */
        beautyAndPersonalCareCategory: '美妆/个护/清洁类',
        hairCare: '洗发/美发/护发',
        womenSkincare: '女士护肤',
        homeCleaning: '家庭清洁',
        bodyCare: '身体护理',
        feminineCare: '女性护理',
        oralCare: '口腔护理',
        menSkincare: '男士护肤',
        makeup: '彩妆',
        fragrances: '香氛',
        beautyServices: '美妆服务',
        otherBeautyAndPersonalCare: '其他美妆/个护/清洁',
        /**----------------------- */
        maternalAndInfantProductsCategory: '母婴用品类',
        babyFood: '婴幼儿食品',
        babyCareEssentials: '婴幼儿用品',
        babyToys: '婴幼儿玩具',
        otherMaternalAndInfantProducts: '其他母婴用品',
        /**----------------------- */
        networkAndCommunicationCategory: '网络及通讯类',
        mobileCarriers: '移动通信运营商',
        internetProviders: '互联网提供商',
        telecomEquipment: '通信设备',
        otherNetworkAndCommunication: '其他网络及通讯',
        /**----------------------- */
        travelAndAccommodationCategory: '旅游住宿类',
        localTourism: '旅游/区域',
        bookingPlatform: '预订平台',
        hotels: '旅馆',
        airlines: '飞机',
        airport: '机场',
        otherTravelAndAccommodation: '其他旅游住宿',
        /**----------------------- */
        vehiclesCategory: '交通运输类',
        motorVehicleProductsAndServices: '机动车产品和服务',
        carBrands: '汽车品牌',
        dealerships: '汽车经销商',
        carFinance: '汽车金融',
        evCar: '电动汽车',
        motorcycle: '摩托车',
        onlineUsedCarMarketplace: '二手车网上交易平台',
        carRentalPlatform: '汽车租赁平台',
        travelNavigation: '出行导航',
        bicycle: '自行车',
        otherVehicles: '其他交通工具',
        /**----------------------- */
        householdAppliancesCategory: '家用电器类',
        majorAppliances: '大家电',
        healthAndPersonalCareAppliances: '个护健康电器',
        majorKitchenAndBathAppliances: '厨卫大电',
        smallKitchenAppliances: '厨房小电',
        environmentalAppliances: '环境电器',
        cleaningAppliances: '清洁电器',
        otherHouseholdAppliances: '其他家用电器',
        /**----------------------- */
        retailAndServiceCategory: '零售及服务类',
        onlineRetailEcommerce: '在线零售/电商',
        departmentStores: '百货商店',
        lifeServices: '生活服务业',
        retailServicesAndDelivery: '零售服务/配送',
        supermarkets: '超市',
        otherRetailAndService: '其他零售及服务',
        /**----------------------- */
        apparelCategory: '服装服饰类',
        footwear: '鞋履',
        clothing: '服装',
        watchesWatchRetail: '手表/表行',
        jewelry: '珠宝首饰',
        bags: '箱包',
        eyewearOpticalStores: '眼镜/眼镜店',
        otherClothingAndAccessories: '其他服装服饰',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: '家装家居类',
        homeFurnishing: '家居',
        homeImprovement: '家装',
        otherHomeImprovementAndFurnishings: '其他家装家居',
        /**----------------------- */
        financialAndInsuranceCategory: '金融/理财/保险类',
        bank: '银行',
        fintech: '互联网金融',
        investmentAndFinancialServices: '金融理财',
        insurance: '保险',
        otherFinancialAndInsurance: '其他金融/理财/保险',
        /**----------------------- */
        entertainmentAndLeisureCategory: '休闲娱乐类',
        socialApp: '社交APP',
        toysAndDolls: '玩具玩偶',
        concerts: '演唱会',
        events: '体育赛事',
        movies: '电影',
        themeParks: '主题乐园',
        gambling: '博彩',
        onlineGaming: '网络游戏',
        tvChannels: '电视频道',
        otherEntertainmentAndLeisure: '其他休闲娱乐',
        /**----------------------- */
        industrialAndAgriculturalCategory: '工业农业类',
        industrialSupplies: '工业用品',
        agriculturalSupplies: '农业用品',
        otherIndustrialAndAgricultural: '其他工业农业',
        /**----------------------- */
        petLifeCategory: '宠物生活类',
        petFood: '宠物食品',
        petSupplies: '宠物用品',
        otherPetLife: '其他宠物生活',
        /**----------------------- */
        educationAndLearningCategory: '教育与学习类',
        onlineLearning: '在线教育',
        schools: '学校',
        skillCourses: '技能课程',
        tutoring: '辅导服务',
        universities: '大学',
        otherEducationAndLearning: '其他教育与学习',
        /**----------------------- */
        communityAndPublicServiceCategory: '社区与公共服务类',
        charityCampaigns: '慈善活动',
        ngoAds: '非政府组织广告',
        otherCommunityAndPublicService: '其他社区与公共服务',
        /**----------------------- */
        otherCategory: '其他类',
        governmentAdvertising: '政府广告',
        realEstateAdvertising: '房地产广告',
        otherAdvertising: '其他广告',
      },
      genderSelect: {
        male: '男性',
        female: '女性',
        all: '全部',
      },
      targetMarketSelect: {
        China: '中国',
        HongKongChina: '中国香港',
        MacauChina: '中国澳门',
        TaiwanChina: '中国台湾',
        Japan: '日本',
        Korea: '韩国',
        Mongolia: '蒙古',
        Singapore: '新加坡',
        Thailand: '泰国',
        Vietnam: '越南',
        Malaysia: '马来西亚',
        Philippines: '菲律宾',
        Indonesia: '印度尼西亚',
        Cambodia: '柬埔寨',
        Laos: '老挝',
        India: '印度',
        SaudiArabia: '沙特阿拉伯',
        Turkey: '土耳其',
        Israel: '以色列',
        UnitedArabEmirates: '阿拉伯联合酋长国',
        Qatar: '卡塔尔',
        Kuwait: '科威特',
        UnitedKingdom: '英国',
        France: '法国',
        Germany: '德国',
        Netherlands: '荷兰',
        Belgium: '比利时',
        Austria: '奥地利',
        Italy: '意大利',
        Spain: '西班牙',
        Portugal: '葡萄牙',
        Greece: '希腊',
        Sweden: '瑞典',
        Norway: '挪威',
        Finland: '芬兰',
        Denmark: '丹麦',
        Estonia: '爱沙尼亚',
        Latvia: '拉脱维亚',
        Russia: '俄罗斯',
        Poland: '波兰',
        CzechRepublic: '捷克共和国',
        Hungary: '匈牙利',
        Romania: '罗马尼亚',
        Bulgaria: '保加利亚',
        Slovakia: '斯洛伐克',
        Slovenia: '斯洛文尼亚',
        Ukraine: '乌克兰',
        UnitedStates: '美国',
        Canada: '加拿大',
        Mexico: '墨西哥',
        Brazil: '巴西',
        LatinAmerica: '拉丁美洲',
        Australia: '澳大利亚',
        NewZealand: '新西兰',
        Other: '其他',
      },
      languageSelect: {
        english: '英文',
        chinese: '简体中文',
        japanese: '日文',
        korean: '韩文',
        french: '法文',
        traditionalChinese: '繁体中文',
      },
      placeholder: {
        projectName: '请输入项目名称',
        category: '请选择类别',
        brandName: '请输入品牌名称',
        adName: '请输入广告名称',
        norm: '请选择基准值',
        taGender: '请选择性别',
        targetMarket: '请选择目标市场',
        taAge: '请选择年龄',
        lowerLimit: '下限',
        upperLimit: '上限',
        outputLanguage: '请选择输出语言',
      },
      step: {
        step1: '项目信息录入',
        step2: '订单信息确认',
      },
      message: {
        success: '创建成功',
        videoDurationOver60s: '视频时长超过{{max}}秒',
        videoDurationLessThan10s: '视频时长小于{{min}}秒',
        videoDurationNeedOver10s: '视频时长需超过 10s',
        videoDurationNeedWithin5To10s: '视频时长需处于 5s - 10s 中',
        videoDurationNotMatchDurationCategory: '当前视频时长不满足该类型的项目测试，请重新上传视频后重试',
        videoUploadingCannotSwitchDurationCategory: '视频上传过程中不可切换创意类型，请等待上传完成',
        videoFormatOrDurationError: '无法读取视频格式或时长，请检查视频文件后重试',
        videoSizeOver200M: '视频大小超过256M',
        videoLandscape: '视频需为横屏尺寸',
        videoPortrait: '视频需为竖屏尺寸',
        clickToUploadTestVideo: '点击上传测试视频',
        uploadFailed: '上传失败，请重新上传',
        uploadDesc1: '支持视频文件为横屏尺寸，格式为MP4, MOV',
        uploadDescPortrait: '支持视频文件为竖屏尺寸，格式为MP4, MOV',
        uploadDesc2: '文件大小限制为256MB',
        formNotCompleted: '请填写完整信息',
        uploadAdVideo: '请上传广告视频',
        inputInvalid: '输入内容无效',
        insufficientTestPoints: '当前测试次数不足，请充值后进行尝试。',
        reviewProjectInfo: '请仔细检查您的项目信息。一旦订单确认，将无法更改。',
        waitingDesc:
          '最多可同时分析3个项目。超出数量的项目会进入等待队列，系统将按照顺序进行分析。',
        ageRangeInvalid: '年龄范围仅支持20～55',
        normDesc: '无限版权益，企业定制的自有基准值',
      },
    },
    projectDetailPage: {
      testResults: '测试结果',
      share: '分享',
      shareFailed: '分享失败',
      shareModal: {
        title: '分享',
        desc: '复制以下文本并分享至社交媒体。',
        saveImage: '保存图片',
        copyText: '复制文案',
        copySuccess: '复制成功',
        copyFailed: '复制失败',
        textTemplate:
          '厉害了！我的 AI 视频在 AdEff 测试中击败了{{score}}%的同类作品！数据才是硬实力! AdEff AI广告测评免费进行中，快登录 {{hostname}} 看看你的创作能得多少分?每人享 5 次机会，祝你马上好评！',
      },
      sharePoster: {
        createdByYou: '您创作的',
        scoreTemplate: '超过了<score>{{score}}</score>的 AIGC 创意',
        statsAt: '统计于',
        certification: '创意认证',
        footerText: '期待您持续创作，带来更多优质作品!',
      },
      basicInformation: '基本信息',
      waiting: '等待中',
      ongoing: '正在进行',
      failed: '失败',
      tryAgain: '重试',
      videoAnalysisFailed: '视频分析失败',
      message: { projectNotFound: '找不到项目' },
      primaryAnalysis: '关键表现',
      detailAnalysis: '时刻解析',
      heatmapAnalysis: '热力图',
      analysisStepDesc: 'AI已完成了所有分析任务，详细分析如下',
      analysisWaitingDesc: '最多同时分析3个项目。该项目已进入等待队列，稍后自动开始分析',
      aiTip: '报告内容均由 AI 生成，仅供参考',
      subAnalysisDescription: {
        adVideoScore: '广告效果指数',
        adVideoScoreDesc:
          '广告效果指数是衡量广告有效性的综合指标，能够预测广告带来的短期和长期销售效果。',
        norm: '基准值',
        normDesc: '行业或历史数据的基准值，用于横向对比广告表现。',
        attentionIndex: '注意指数',
        attentionIndexDesc: '受众视觉注意力集中情况，反映广告画面中情节及元素吸引观看的能力。',
        emotionIndex: '情绪指数',
        emotionIndexDesc: '受众正向情绪被激发的程度，反映由广告引发即时性的情绪波动。',
        cognitionIndex: '认知指数',
        cognitionIndexDesc: '反映受众认知加工的程度，即在多大程度上对广告内容进行了思考。',
        theGolden3Seconds: '黄金3秒',
        theGolden3SecondsDesc: '广告的前3秒是决定广告成功与否的关键时刻。',
        informationTransmission: '信息时刻',
        informationTransmissionDesc: '衡量广告信息时刻对目标受众注意力的捕获能力及兴趣激发的效果。',
        brandRelevance: '品牌时刻',
        brandRelevanceDesc: '衡量品牌时刻对目标受众注意力的捕获能力及兴趣激发的效果。',
        interestStimulation: '兴趣时刻',
        interestStimulationDesc: '引发受众情感共鸣与主动认知的关键内容时刻。',
        theEnding3Seconds: '结尾3秒',
        theEnding3SecondsDesc:
          '基于峰终定律，广告的最后3秒是巩固观众注意力和加强信息传递的关键时刻。',
      },
      infoDrawer: {
        basicInformation: '基本信息',
        advertisingInformation: '广告信息',
        projectName: '项目名称',
        brandName: '品牌名称',
        category: '行业',
        norm: '目标市场基准值',
        normLabel: '基准值',
        brandNorm: '品牌基准值',
        adName: '广告名称',
        taGender: 'TA 性别',
        targetMarket: '目标市场',
        taAge: 'TA 年龄',
        ageRange: '{{start}} 到 {{end}} 岁',
        modify: '修改',
        cancel: '取消',
        confirm: '确定',
      },
      videoView: {
        eyeMovementRatio: '注意指数',
        cognitiveEngagement: '认知指数',
        emotionRecognition: '情绪指数',
        subjectiveResponseCurve: '主观反应曲线',
        realtimeData: '实时数据',
        panoramicData: '全局数据',
        indexAnalysis: '指标分析',
        advantage: '优势',
        disadvantage: '劣势',
        suggestions: '建议',
        adVideoScore: '广告效果指数',
        norm: '基准值',
        analysisStepTitle1: '内容解码',
        analysisStepTitle2: '反馈预测',
        analysisStepTitle3: '数据整合',
        analysisStepTitle4: '结论推理',
        analysisStepDesc1: '开始进行广告内容多模态解码，解码视觉、解码音频、解码文本、解码结构...',
        analysisStepDesc2: '开始预测受众主观反应，基于广告的分秒内容，预测受众眼动和脑电数据...',
        analysisStepDesc3: '开始整合广告客观内容和受众主观反应数据...',
        analysisStepDesc4: '开始基于推理模型，生成评估结论和行动建议...',
        keyResult: '核心结果',
        videoChart: {
          videoFailed: '视频无法播放',
          videoFailedAction: '请刷新后重试。若多次刷新仍未解决，请联系我们处理。',
        },
      },
      storyboardView: {
        summary: '总结',
        advantages: '优势',
        disadvantages: '劣势',
        suggestions: '建议',
        keyResult: '核心结果',
        norm: '基准值',
        theGolden3Seconds: '黄金3秒',
        informationTransmission: '信息时刻',
        brandRelevance: '品牌时刻',
        interestStimulation: '兴趣时刻',
        theEnding3Seconds: '结尾3秒',
      },
      heatmapView: {},
    },
    accountPage: {
      email: '电子邮箱',
      username: '用户名',
      password: '密码',
      setPasswordToEnableEmailLogin: '设置密码以启用电子邮件登录',
      uid: 'UID',
      contactAndReceiveNotifications: '联系并接收通知',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        '通过此电子邮件接收有关AdEff最新更新的电子邮件。',
      myWorkspace: '我的工作区',
      newRequest: '新请求',
      invitationCode: '推荐码',
      userName: '用户名',
      invitationCodeDesc: '每个团队都有一个独特的邀请代码，用于新用户在注册期间请求加入团队',
      table: {
        userName: '用户名',
        email: '电子邮箱',
        operation: '操作',
        admin: '管理员',
        remove: '移除',
        deny: '拒绝',
        approve: '同意',
      },
      message: {
        yourTeamIsFull: '您的团队已满员。您可以联系我们以获得更多会员资格或移除其他成员。',
        invitationLinkSent: '邀请链接已发送到此电子邮件地址！',
        removeReminder: '移除提醒',
        remove: '移除',
        removeMember: '删除成员后，该成员创建的内容仍将保留。您想继续删除成员吗？',
        removeMemberSuccess: '成员删除成功！',
        ok: '好的',
        contactUs: '联系我们',
        applicationProcessedSuccessfully: '申请处理成功！',
        notificationSettingsTurnedOn: '通知设置已打开',
        notificationSettingsTurnedOff: '通知设置已关闭',
        setPassword: '设置密码',
        passwordConfirm: '确认',
        passwordCancel: '取消',
        oldPassword: '旧密码',
        newPassword: '新密码',
        pleaseEnterTheOldPassword: '请输入旧密码',
        pleaseEnterTheNewPassword: '请输入新密码',
        incorrectEntryOfOriginalPassword: '原始密码输入错误',
        passwordUpdatedSuccessfully: '密码更新成功',
        changeUsername: '修改用户名',
        confirm: '确认',
        cancel: '取消',
        username: '用户名',
        pleaseEnterTheNewUsername: '请输入新用户名',
        userNameUpdatedSuccessfully: '用户名更新成功',
        addMemberToWorkspace: '添加新成员到工作区',
        notAdminOperate: '非管理员，无法进行操作',
        emailAddress: '电子邮件地址',
        send: '发送',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          '我们将向此地址发送一封邀请电子邮件以进行确认。',
        workspaceMemberShip: '工作区会员',
        forMoreMembership: '更多会员资格',
        reachedTheCeiling: '人数已达到上限。',
        incorrectMailboxFormat: '邮箱格式不正确',
        member: '成员',
        changeCorpNameTitle: '修改公司名称',
        changeCorpNameLabel: '公司名称',
        pleaseEnterTheCorpName: '请输入公司名称',
        changeCorpNameSuccess: '公司名称修改成功',
        changeCorpNameFailed: '公司名称修改失败',
        noPermission: '您没有权限修改公司名称',
      },
    },
    subscriptionPage: {
      currentPlan: '当前计划',
      getInvoice: '获取发票',
      remainingTimes: '剩余次数',
      purchaseMore: '购买更多',
      contactUs: '联系我们',
      teamPlan: '专家团队服务',
      unlimited: '无限版',
      dueDate: '到期日期',
      table: {
        usageRecords: '使用记录',
        date: '日期',
        projectName: '项目名称',
        projectType: '项目类型',
        usageCount: '次数',
        userName: '用户名',
        noRelevantContent: '找不到相关内容',
      },
    },
    dataDetailPage: {
      baseData: '基础数据',
      totalProjects: '项目总数',
      totalProjectsDesc: '所有参与广告效果评估的有效项目数量。',
      // averageEffectivenessIndex: '效果指数均值',
      // averageEffectivenessIndexDesc: '所有有效项目的广告效果指数的平均值。',
      localNormProjects: '本地基准值项目数',
      brandNormProjects: '品牌基准值项目数',
      normProject: '目标市场基准值项目',
      brandNormProject: '品牌基准值项目',
      localNorm: '本地基准值',
      localNormDesc: '以您所在国家为目标市场的有效广告项目的广告效果指数平均值。',
      norm: '基准值',
      brandNorm: '品牌基准值',
      brandNormDesc: '以您定制的品牌基准值评估的有效广告项目的广告效果指数平均值。',
      localProjectPassRate: '本地项目通过率',
      projectPassRate: '项目通过率',
      brandProjectPassRate: '品牌项目通过率',
      projectPassRateDesc: '广告效果指数得分高于基准值的项目数量占所有评估项目总数的比例。',
      advertisingEffectivenessIndexDistribution: '广告效果指数分布',
      advertisingEffectivenessIndexDistributionDesc: '展示不同广告效果指数区间的项目比例。',
      item: '项',
    },
    dataComparisonPage: {
      createCompare: '新建对比',
      createCompareDesc: '支持多选项目进行对比，最多选择 10 个项目。',
      startCompare: '开始对比',
      compareReport: '对比报告',
      searchPlaceholder: '搜索对比报告名称',
      emptyText: '当前暂无对比报告，请先选择项目进行对比',
      searchEmptyText: '未搜索到对比报告',
      deleteTitle: '删除对比报告',
      deleteConfirm: '确认删除该对比报告？删除后不可恢复。',
      projectCount: '{{count}} 个项目',
    },
    dataComparisonStartPage: {
      back: '返回',
      basicInfo: '基本信息',
      reportName: '报告名称:',
      reportNamePlaceholder: '请输入对比报告名称',
      norm: '基准值:',
      normPlaceholder: '请选择基准值',
      normTip: '请选择项目对比时使用的基准值',
      selectProject: '选择项目',
      searchPlaceholder: '输入项目/广告/品牌名称搜索',
      selectedCountPrefix: ' 已选择 ',
      selectedCountSuffix: ' 个项目，最多选择{{max}}个项目',
      startCompare: '开始对比',
      save: '保存',
      cancel: '取消',
      maxSelectedWarning: '最多选择 10 个项目',
      reportNameRequired: '请输入对比报告名称',
      normRequired: '请选择基准值',
      projectRequired: '请选择项目',
    },
    dataComparisonInfoPage: {
      defaultReportName: '对比报告名称',
      reportNotFound: '报告不存在',
      back: '返回',
      modify: '修改',
      deletedProjectTip: '以下项目：{{names}} 已被删除，确认后将更新对比报告并移除已删除项目',
      confirmDeletedProjects: '确认',
      metricScore: '指标得分',
      tabDimension: '五大维度',
      tabMoment: '关键时刻',
      tabAttitude: '消费者态度',
      adeffScore: 'AdEff 得分',
      brandName: '品牌名称',
      projectName: '项目名称',
      industry: '行业',
      targetMarket: '目标市场',
      gender: 'TA性别',
      age: 'TA年龄',
      adProject: '广告项目',
      normLabel: '基准值',
      mixedCreativeBenchmarkTip: '当同时对比常规创意和开屏创意时，无基准值',
      emptyProject: '请选择项目后查看对比信息',
      viewProjectDetail: '查看项目详情',
      listSeparator: '、',
      metricLabels: {
        attention: '注意力',
        infectivity: '感染力',
        delivery: '传达力',
        brand: '品牌力',
        persuasion: '说服力',
        gazeRecognition: '注视识别',
        emotionRecognition: '情绪识别',
        engagementRecognition: '投入识别',
        goldenSeconds: '黄金3秒',
        brandMoment: '品牌时刻',
        productMoment: '兴趣时刻',
        messageMoment: '信息时刻',
        endingSeconds: '结尾3秒',
        likeability: '喜好度',
        newInformation: '新信息',
        messageRelevance: '相关度',
        comprehension: '理解度',
        credibility: '可信度',
        brandLinkage: '契合度',
        uniqueness: '独特性',
        learnMoreIntent: '了解意愿',
        purchaseIntent: '购买意愿',
        recommendIntent: '分享意愿',
        brandLikeabilityLift: '品牌好感提升',
        purchaseIntentionLift: '购买意愿提升',
        attentionIndex: '注意指数',
        emotionIndex: '情绪指数',
        cognitionIndex: '认知指数',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: '常规创意项目',
      regularCreative: '常规创意',
      splashCreativeProject: '开屏创意项目',
      splashCreative: '开屏创意',
      projects: '项目数',
      localNorm: '本地基准值',
      projectPassRate: '项目通过率',
      passRate: '通过率',
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: '您的横屏-深度洞察项目已完成',
        title: {
          text1: '广告创意测试',
          text2: '测试报告',
        },
        flowAnalysis: {
          desc1: 'AdEff 正在解构视频',
          desc2: '视频解构完毕',
          desc3: '正在分析消费者视觉注意力',
          desc4: '基于消费者画像，分析关注焦点',
          desc5: '正在生成热力图',
          desc6: '动态热力图已生成',
          desc7: '正在测量认知神经反应',
          desc8: '正在逐秒分析消费者注视、情绪、投入反应',
          desc9: '认知神经曲线生成中',
          desc10: '认知神经曲线已生成',
          desc11: '分析广告关键时刻表现',
          desc12: '测量黄金3秒、信息时刻、品牌时刻、兴趣时刻、结尾3秒的认知神经反应',
          desc13: '关键时刻指标合成中',
          desc14: '关键时刻分析完成',
          desc15: '消费者态度分析中',
          desc16: '正在分析消费者对品牌、产品与内容的态度倾向',
          desc17: '态度指标合成中',
          desc18: '态度指标分析已完成',
          desc19: '正在生成五大维度指标',
          desc20: '五大维度指标已完成',
          desc21: '全部分析完成，快来看看您的广告表现吧!',
          terminology: {
            thumbExpand: '展开缩略图',
            thumbCollapse: '收起缩略图',
            gazeRecognition: '注视识别',
            gazeRecognitionDesc:
              '消费者视觉注意力集中情况，反映广告画面中情节及元素吸引观看的能力。',
            emotionRecognition: '情绪识别',
            emotionRecognitionDesc: '消费者正向情绪被激发的程度，反映由广告引发即时性的情绪波动。',
            engagementRecognition: '投入识别',
            engagementRecognitionDesc:
              '消费者投入和沉浸程度，反映在多大程度上对广告内容进行了思考。',
            theGolden3Seconds: '黄金3秒',
            theGolden3SecondsDesc: '评估广告最初3秒的内容表现。',
            keyMessage: '信息时刻',
            keyMessageDesc: '衡量广告信息时刻对目标受众注意力的捕获能力及兴趣激发的效果。',
            brand: '品牌时刻',
            brandDesc: '衡量品牌时刻对目标受众注意力的捕获能力及兴趣激发的效果。',
            interest: '兴趣时刻',
            interestDesc: '引发受众情感共鸣与高投入度的关键内容的表现。',
            ending3Seconds: '结尾3秒',
            ending3SecondsDesc: '评估广告结尾3秒的内容表现。',
            score: '得分',
            benchmark: '基准值',
            metrics: '指标',
            attitudePart: {
              attitudeMetrics: '态度指标',
              liking: '喜好度',
              likingDesc: '受众对广告的主观态度，衡量整体喜欢程度。',
              newInformation: '新信息',
              newInformationDesc: '衡量受众在观看广告后，主观上是否认为从广告中获得了此前未知的、关于品牌或产品的有价值的信息。',
              messageRelevance: '相关度',
              messageRelevanceDesc: '衡量受众主观上是否认为广告所传递的信息与自身有直接关联。',
              comprehension: '理解度',
              comprehensionDesc: '衡量广告所传递的核心信息是否被受众清晰、准确、不费力地理解。',
              credibility: '可信度',
              credibilityDesc: '衡量受众在多大程度上相信广告所传达的信息是真实、可靠、值得信赖的。',
              brandLinkage: '契合度',
              brandLinkageDesc: '衡量受众能否正确且强烈地将广告内容与特定品牌关联起来。',
              uniqueness: '独特性',
              uniquenessDesc: '衡量广告是否建立起该品牌相对于竞争对手具有鲜明且有价值的独特之处的清晰认知。',
              willing: '了解意愿',
              willingDesc: '衡量受众在观看广告后，主动采取行动去进一步了解和探索品牌或产品相关信息的主观可能性。',
              purchase: '购买意愿',
              purchaseDesc: '衡量受众在观看广告后，在未来某个时期考虑选择或购买该品牌产品的主观可能性。',
              share: '分享意愿',
              shareDesc: '衡量受众在观看广告后，主动将广告或品牌信息分享给他人的主观可能性。',
              brandLikeLift: '品牌好感提升',
              brandLikeLiftDesc: '衡量广告播放后，受众对品牌或产品的喜好程度发生了何种方向及何种程度的变化。',
              purchaseIntentLift: '购买意愿提升',
              purchaseIntentLiftDesc: '衡量广告播放后，受众考虑购买该品牌产品的意愿发生了何种方向及何种程度的变化。',
            },
            dimensionPart: {
              forceDrives: '维度指标',
              attension: '注意力',
              emotionalImpact: '感染力',
              messageClarity: '传达力',
              brandPower: '品牌力',
              persuasion: '说服力',
              attentionForce: '注意力',
              attentionForceDesc: '衡量创意吸引并维持消费者视觉与听觉注意的能力。',
              emotionalForce: '感染力',
              emotionalForceDesc: '衡量创意激发观众本能、即时的情感共鸣与情绪波动的强度。',
              messageForce: '传达力',
              messageForceDesc: '衡量创意的核心信息被目标观众清晰识别、准确理解和深刻记忆的有效性。',
              brandForce: '品牌力',
              brandForceDesc: '衡量创意强化品牌身份、提升品牌好感并建立深刻品牌关联的效能。',
              persuasiveForce: '说服力',
              persuasiveForceDesc: '衡量创意改变用户认知、驱动行为意向的最终转化能力。',
            },
            result: {
              results: '结果',
              pass: '通过',
              notPass: '不通过',
              adeffScore: 'AdEff得分',
              adeffScoreDesc: 'AdEff得分旨在衡量广告的整体有效性。',
              benchmarkDesc: '广告所在国家/地区所有上传广告的AdEff得分均值，用于对比广告在该国家/地区的表现。',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: '等待中...',
            description: '正在为您生成测试报告...',
          },
          generating: '持续生成中...',
          freeTrialLockText1: '试用状态无法预览或下载完整报告，',
          freeTrialLockText2: '充值后即可解锁。',
        },
      },
    },
  },
  professor: {
    account: '账号',
    password: '密码',
    login: '登录',
    expertReviews: '专家评测',
    adVideoScore: '广告效果指数',
    subjectiveResponseCurve: '主观反应曲线',
    indexAnalysis: '指标分析',
    keyResult: '核心结果',
    theGolden3Seconds: '黄金3秒',
    informationTransmission: '信息时刻',
    brandRelevance: '品牌时刻',
    interestStimulation: '兴趣时刻',
    theEnding3Seconds: '结尾3秒',
    heatMap: '热力图',
    suggestion: '反馈建议',
    suggestion1: '建议',
    submit: '提交',
    next: '下一题',
    summary: '总结',
    advantages: '优势',
    disadvantages: '劣势',
    option1: '符合预期',
    option2: '不符合预期',
    resultJudgment: '结果判断',
    placeholder: '请输入建议',
    waitRateCount: '待评测广告数量',
    unfinishedTitle: '提醒',
    unfinishedRate: '当前项目还有未评测内容，是否确认退出？',
    unfinishedConfirm: '继续评测',
    unfinishedCancel: '退出',
    message: {
      submitSuccess: '感谢您的评价',
      submitSuccess1: '您已完成该项目的评测，感谢您的评价',
      loginSuccess: '登录成功',
      rateUnfinished: '您还未评测当前内容，请填写后再进入下一题',
      rateLocation: '已为您自动定位到未评测内容',
    },
  },
  modals: {
    freeTrialModal: {
      title: '申请试用',
      title1: '免费试用',
      trial: '试用',
      hiddenBoxText1: '检测到多项优势、劣势、建议',
      hiddenBoxText2: '订阅后可获取完整报告',
      hiddenBoxBtn: '立即订阅',
      applyBox: {
        name: '您的姓名',
        tel: '联系电话',
        department: '部门',
        role: '职位',
        country: '国家',
        city: '城市',
        pleaseEnter: '请输入',
        pleaseSelect: '请选择',
        pleaseEnterTheName: '请输入您的姓名',
        pleaseEnterTheTel: '请输入您的联系方式',
        pleaseEnterValidTel: '请输入有效的联系方式',
        pleaseEnterValidEmail: '请输入有效的邮箱',
        pleaseSelectTheDepartment: '请选择您的部门',
        pleaseSelectTheRole: '请选择您的职位',
        pleaseSelectTheCountry: '请选择您的国家',
        pleaseEnterTheCity: '请输入您的城市',
        textIsRequired: '此字段为必填项',
        submit: '提交',
        tip: '每家企业仅有一次免费试用机会',
      },
      gotTrial: '您已获得试用机会！',
      goPc: '请前往PC网页端创建项目。',
      back: '返回',
      country: {
        China: '中国',
        Japan: '日本',
        Korea: '韩国',
        Indonesia: '印度尼西亚',
        Thailand: '泰国',
        Singapore: '新加坡',
        Malaysia: '马来西亚',
        Vietnam: '越南',
        Germany: '德国',
        Britain: '英国',
        France: '法国',
        Italy: '意大利',
        Russia: '俄罗斯',
        Spain: '西班牙',
        Turkey: '土耳其',
        America: '美国',
        Canada: '加拿大',
        Brazil: '巴西',
        Other: '其它',
      },
      department: {
        Brand: '品牌部',
        Market: '市场研究及洞察部',
        Marketing: '营销部',
        IT: 'IT或数字化部',
        Procurement: '采购部',
        Other: '其它',
      },
      role: {
        President: '总裁/副总裁/总经理',
        CMO: 'CMO或其他C-level管理层',
        Director: '部门总监',
        Manager: '部门经理',
        Other: '其它',
      },
      message: {
        submitSuccess: '提交成功',
        submitFailed: '提交失败，请稍后再试',
      },
    },
    downloadPptRechargeModal: {
      title: '无法下载',
      desc1: '试用状态下无法下载',
      desc2: '订阅后可下载完整报告',
      btn: '立即订阅',
    },
    checkInvitationCodeModal: {
      invitationCode: '推荐码',
      invitationCodeDesc1: '推荐码信息不可修改，如需修改，请联系我们',
      invitationCodeDesc2: '如果您因代理公司推荐使用 AdEff，请在此处填写代理公司的推荐码。',
      invitationCodePlaceholder: '请输入推荐码',
      invitationCodeError: '推荐码有误',
      invitationCodeSuccess: '绑定成功',
      ok: '确定',
      cancel: '取消',
    },
    aigcPromotionModal: {
      title: 'AIGC 创作者福利',
      subTitle: '注册即可获得 <tmp>5</tmp> 次AI视频测评机会',
      desc1: '参与 AIGC 创意测试专项活动，用 AdEff 为你的 AIGC 创意进行全方位测评！',
      desc2: '点击下方完成注册，即刻免费领取 5 次 AIGC 创意测试机会。',
      registerBtn: '注册获取测试机会',
      tip: '仅限通过 AIGC 创作者活动入口注册的新用户',
      floatTitle: '免费测试',
    },
  },
}

export default TRANSLATION
